<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="secondary"
                 flat
                 card
                 dense>
        <v-toolbar-title class="white--text">
          {{ $t(activeSection) }}
        </v-toolbar-title>
      </v-toolbar>
    </v-card-title>

    <v-form ref="form"
            v-model="valid"
            md-6
            v-on:submit.prevent="() => { return false }"
            offset-3>
      <v-card-text>
        <v-text-field :label="$t('global.placeholder.username')"
                      v-model="username"
                      name="username"
                      :rules='usernameRules'
                      type="email"
                      required>
        </v-text-field>
      </v-card-text>

      <v-card-actions class="justify-end pb-3">
        <v-btn :to="{path:$t('urlLogin')}"
               round
               flat
               color="primary"
               class="capitalize">
          {{$t('global.action.back')}}
        </v-btn>
        <v-btn :disabled='!valid'
               :loading="isLoading"
               round
               flat
               color="accent"
               class="capitalize"
               outline
               @click="submit">
          {{$t('global.button.send')}}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import authService from '@/services/authService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ForgotPassword',
  computed: {
    activeSection() {
      return store.state.activeSection;
    }
  },
  data() {
    return {
      username: store.state.forgotUser,
      usernameRules: [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) || this.$i18n.t('global.validation.email.format')
      ],
      isLoading: false,
      valid: false
    };
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }
      let params = {
        lang: store.state.langSelected.langWsp,
        city: `CITY__${store.state.citySelected.code}`,
        username: this.username
      };
      this.isLoading = true;

      let results = await authService.forgotPassword(params);
      if (results.error) {
        if (results.status === 412) {
          let message = this.$i18n.t('forgot.error.412');
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: message,
            type: 'error',
            doNotTranslate: true
          });
          this.isLoading = false;
          return;
        }

        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('forgot.toast.success', { username: this.username }),
        type: 'success',
        doNotTranslate: true
      });

      this.isLoading = false;
    }
  }
};
</script>
